import React, { useState } from "react";
import { FormButton, SpinnerOverlay } from "components";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import { RNHAgenteAsignarDel } from "services/services-mia/programa-salud/personal/RNHAgenteAsignarDel";
import styles from "./EliminarModal.module.scss";

/**
 * Borrado de una asignación. NO es lo mismo que "Desasignar", que está al lado y parece
 * igual — ver el README del módulo.
 *
 * Como el registro deja de existir, el modal confirma con nombre y lugar a la vista. El
 * AGENTE no se toca: sigue existiendo, con una asignación menos.
 */

export default function EliminarModal({
  row,
  asignacion,
  updateList,
  limpiarSeleccion,
  closeModal,
}) {
  const credentials = useRecoilValue(userCredentials);
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const [inRequest, setInRequest] = useState(false);

  const eliminar = async (e) => {
    e.preventDefault();
    setInRequest(true);

    const respuesta = await RNHAgenteAsignarDel(credentials, {
      lugarId: asignacion?.id,
      lugarVersion: asignacion?.version,
    });

    setInRequest(false);
    if (!respuesta.ok) return;

    setSnackBarInfo({
      message: "Asignación eliminada correctamente",
      severity: "success",
      open: true,
    });
    limpiarSeleccion?.();
    updateList?.();
    closeModal?.();
  };

  return (
    <form className={styles.contenedor} onSubmit={eliminar} noValidate>
      <p className={styles.texto}>
        Vas a eliminar la asignación de <strong>{row?.apellidosNombres}</strong> en{" "}
        <strong>{asignacion?.lugar}</strong>.
      </p>
      <p className={styles.aclaracion}>
        Se borra el registro de esa asignación: no es lo mismo que desasignar, que lo
        deja sin lugar pero se puede volver atrás. El agente sigue existiendo, con una
        asignación menos.
      </p>

      <FormButton
        inRequest={inRequest}
        newFormData={{ button: "Eliminar" }}
        onCloseModal={closeModal}
      />
      {inRequest && <SpinnerOverlay />}
    </form>
  );
}
